import React, { useEffect } from 'react';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { useTranslation } from 'react-i18next';
import { useDropShiftModalContentData } from '../DropShiftModalContent/utils';
import { Text } from '@amzn/atoz-web/Text';
import { Card, Col, IconAlertTriangleFill, Row, View } from '@amzn/atoz-web';
import { DateTime } from 'luxon';
import { getButtons } from './MergeShiftConfirmDropModalButtons';
import { PremiumPayMessages } from './PremiumPayMessages/PremiumPayMessages.web';
import { getDateTimeIntervalStringFromShift } from '@amzn/atoz-shiftapp-utilities';
import { isPremiumPayBreakDownAvailable } from '../DropMergedShiftModalContent/utils';
export var MergedShiftConfirmDropModalContent = function (_a) {
    var close = _a.close, dropOpportunity = _a.dropOpportunity, setModalContent = _a.setModalContent, setModalError = _a.setModalError, setSelectedDropOpportunity = _a.setSelectedDropOpportunity, scheduleShift = _a.scheduleShift, showBackButton = _a.showBackButton;
    useEffect(function () {
        setSelectedDropOpportunity(dropOpportunity);
    }, []);
    var _b = useDropShiftModalContentData({
        dropOpportunity: dropOpportunity,
        setModalContent: setModalContent,
        setModalError: setModalError,
        scheduleShift: scheduleShift
    }), onClickDropNow = _b.onClickDropNow, dropNowIsSubmitting = _b.dropNowIsSubmitting, alertMessage = _b.alertMessage;
    var t = useTranslation().t;
    var startTime = DateTime.fromISO(dropOpportunity.shift.timeRange.start);
    var endTime = DateTime.fromISO(dropOpportunity.shift.timeRange.end);
    var hasPayBreakdownPremiums = isPremiumPayBreakDownAvailable(dropOpportunity);
    var hasPremiums = hasPayBreakdownPremiums || !!(dropOpportunity === null || dropOpportunity === void 0 ? void 0 : dropOpportunity.incentivePay);
    return (React.createElement(ModalContent, { dataTestId: "ConfirmDropShiftModalContent", titleText: t('shift_management_features_MultipleDropShiftModal_confirm_drop_title'), buttons: getButtons({
            dropNowIsSubmitting: dropNowIsSubmitting,
            onClickDropNow: onClickDropNow,
            setModalContent: setModalContent,
            showBackButton: showBackButton
        }), onCloseButtonClick: close, closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(Text, { dataTestId: 'merged-shift-confirm-drop-text', fontSize: 'T200', fontWeight: 'light', margin: { bottom: 'S300' } }, t('shift_management_features_MultipleDropShiftModal_confirm_drop_text')),
        React.createElement(Card, { dataTestId: 'merged-shift-confirm-drop-alert-message-card' },
            React.createElement(Col, { gridGap: 20 },
                React.createElement(Text, { fontSize: 'T300', fontWeight: 'bold' }, getDateTimeIntervalStringFromShift(startTime, endTime)),
                alertMessage && (React.createElement(Row, null,
                    React.createElement(Row, { margin: { right: 'S200', top: 'S100' }, alignSelf: "baseline" },
                        React.createElement(IconAlertTriangleFill, { color: "yellow60" })),
                    React.createElement(Text, { margin: { right: 'S200' }, fontSize: "T300", color: "neutral90" }, alertMessage))))),
        hasPremiums && (React.createElement(View, { dataTestId: "merged-shift-confirm-drop-premium-pay-messages" },
            React.createElement(PremiumPayMessages, { dropOpportunity: dropOpportunity, fromPayBreakdown: hasPayBreakdownPremiums })))));
};
